
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"change-avatar\" class=\"settings-unit\">\n  <div class=\"settings-unit-stub\">\n    <header class=\"settings-unit-summary\">\n      <h2 class=\"settings-unit-title\">{{#t}}Account picture{{/t}}</h2>\n    </header>\n    {{#avatar}}\n      <button class=\"settings-button secondary settings-unit-toggle\" data-href=\"settings/avatar/change\">\n      <span class=\"change-button\">{{#t}}Change…{{/t}}</span>\n      </button>\n    {{/avatar}}\n    {{^avatar}}\n      <button class=\"settings-button primary settings-unit-toggle\" data-href=\"settings/avatar/change\">\n      <span class=\"add-button\">{{#t}}Add…{{/t}}</span>\n      </button>\n    {{/avatar}}\n  </div>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/settings/avatar.mustache
// module id = 278
// module chunks = app